export const sxListReservationSummaryRow = {
  table: {
    minWidth: { xs: 300, sm: 500, md: 750 },
    borderSpacing: '0 10px',
    borderCollapse: 'separate',
  },
  tableCell: {
    fontFamily: 'EncodeSans-Medium',
    padding: '0px 16px',
    fontSize: '12px',
    fontWeight: '600',
    textAlign: 'start',
    paddingBottom: '20px',
    border: 'none',
  },
  tableRow: {
    boxShadow: ' 0 0 10px 0 rgba(0, 0, 0, 0.2)',
    borderRadius: '5px',
  },
  tableCellRow: {
    width: '16%',
    fontFamily: 'EncodeSans-Medium',
    border: 'none',
  },
};
